import React, { useEffect, useRef, useState } from "react";

const navGroups = [
  {
    label: "Sales",
    items: [
      { label: "Dashboard", view: "dashboard" },
      { label: "Lead Tracker", view: "leads" },
      { label: "Add Lead", view: "addLead" },
    ],
  },
  {
    label: "Outreach",
    items: [
      { label: "Scripts Library", view: "outreach" },
      { label: "Agent Guide", view: "agentGuide" },
    ],
  },
  {
    label: "Campaigns",
    items: [
      { label: "Campaign Builder", view: "campaignBuilder" },
      { label: "Playbooks", view: "playbooks" },
    ],
  },
  {
    label: "Reporting",
    items: [{ label: "Reports", view: "reports" }],
  },
];

function CRMNavbar({ activeView, setActiveView, handleLogout }) {
  const [openMenu, setOpenMenu] = useState(null);
  const navRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavigate = (view) => {
    setActiveView(view);
    setOpenMenu(null);
  };

  return (
    <header className="crm-navbar" ref={navRef}>
      <button
        className="crm-brand"
        type="button"
        onClick={() => handleNavigate("dashboard")}
      >
        <div className="crm-brand-mark">P</div>

        <div>
          <strong>ProCRM</strong>
          <span>ProCode ZA Growth Workspace</span>
        </div>
      </button>

      <nav className="crm-nav-menu">
        {navGroups.map((group) => (
          <div className="crm-nav-group" key={group.label}>
            <button
              className={`crm-nav-button ${
                openMenu === group.label ? "active" : ""
              }`}
              onClick={() =>
                setOpenMenu(openMenu === group.label ? null : group.label)
              }
              type="button"
            >
              {group.label}
              <span>{openMenu === group.label ? "▲" : "▼"}</span>
            </button>

            {openMenu === group.label && (
              <div className="crm-dropdown-menu">
                {group.items.map((item) => (
                  <button
                    key={item.view}
                    type="button"
                    onClick={() => handleNavigate(item.view)}
                    className={activeView === item.view ? "active" : ""}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      <div className="crm-nav-actions">
        <button
          className="crm-new-lead-btn"
          type="button"
          onClick={() => handleNavigate("addLead")}
        >
          + New Lead
        </button>

        <button
          className="procrm-logout-btn"
          type="button"
          onClick={handleLogout}
        >
          Log out
        </button>
      </div>
    </header>
  );
}

export default CRMNavbar;